var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col justify-center items-center h-36 pb-3 mb-3" },
    [
      _c("h4", { staticClass: "text-xl" }, [
        _vm._v(" To add more managers you need to upgrade your subscription "),
      ]),
      _c(
        "RouterLink",
        {
          staticClass: "text-xl text-primary-500 underline",
          attrs: { to: _vm.pricingLinkName },
        },
        [_vm._v(" Follow this link to manage your subscriptions ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }